module.exports = __webpack_public_path__ + "img/1575301252.b733d8bb.jpg";